__turbopack_context__.v({
  "root": "ChatPanelHeader-module-scss-module__C1ZZUa__root",
  "title": "ChatPanelHeader-module-scss-module__C1ZZUa__title",
});
